// School name merging for exported reports only (e.g. the Schools Ranking
// sheet of the ACT Top Achievers Report). The school names saved on students
// are never changed.
//
// Two rules, applied in order:
//   1. SCHOOL_NAME_GROUPS — any school whose name starts with one of
//      `startsWith` (case-insensitive) is reported as `name`. Use this for
//      branches/divisions whose names differ by more than a suffix.
//   2. Otherwise a trailing division/section/branch is dropped, so
//      "X School - American Division" and "X School (British Section)" are
//      reported as "X School".
//
// To merge another school, add an entry here, e.g.
//   { name: "Some School", startsWith: ["some school", "some sch."] },
export const SCHOOL_NAME_GROUPS = [
  { name: "Akhnaton International School", startsWith: ["akhnaton"] },
];

const DIVISION_SUFFIX = /\s*(?:[-–]\s*[^-–()]*|\(\s*[^()]*)\b(?:division|section|branch)\s*\)?\s*$/i;

export function canonicalSchoolName(raw) {
  const cleaned = String(raw || "").trim().replace(/\s+/g, " ");
  if (!cleaned) return cleaned;
  const lower = cleaned.toLowerCase();
  const group = SCHOOL_NAME_GROUPS.find((g) =>
    g.startsWith.some((prefix) => lower.startsWith(prefix.toLowerCase()))
  );
  if (group) return group.name;
  return cleaned.replace(DIVISION_SUFFIX, "").trim() || cleaned;
}
